<template>
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M22.4211 12.2286C22.4219 11.5472 22.3636 10.8669 22.2467 10.1953H12.7012V14.0467H18.1684C18.0566 14.6618 17.8198 15.2482 17.4723 15.7705C17.1249 16.2927 16.674 16.7401 16.1469 17.0856V19.5856H19.4098C21.3203 17.8453 22.4211 15.2717 22.4211 12.2286Z"
            fill="#4285F4"
        />
        <path
            d="M12.6991 22C15.4306 22 17.7305 21.1139 19.4077 19.5861L16.1448 17.0861C15.2366 17.6944 14.067 18.0417 12.6991 18.0417C10.0589 18.0417 7.81805 16.2833 7.01673 13.9139H3.6554V16.4903C4.49786 18.1465 5.78969 19.5388 7.38666 20.5117C8.98363 21.4846 10.8229 21.9999 12.6991 22Z"
            fill="#34A853"
        />
        <path
            d="M7.01837 13.9142C6.59474 12.6726 6.59474 11.3281 7.01837 10.0865V7.51007H3.65703C2.94832 8.90334 2.57922 10.441 2.57922 12.0003C2.57922 13.5597 2.94832 15.0974 3.65703 16.4906L7.01837 13.9142Z"
            fill="#FBBC04"
        />
        <path
            d="M12.6991 5.95899C14.1426 5.93569 15.5374 6.47451 16.582 7.45899L19.471 4.60482C17.639 2.90493 15.2122 1.97166 12.6991 2.00066C10.8229 2.00074 8.98363 2.51601 7.38666 3.48894C5.78969 4.46186 4.49786 5.85416 3.6554 7.51038L7.01673 10.0868C7.81805 7.71732 10.0589 5.95899 12.6991 5.95899Z"
            fill="#EA4335"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
